<template>
    <a-modal title=""
             :width="960"
             :visible="visible"
             :maskClosable="false"
             @ok="$emit('cancel')"
             @cancel="$emit('cancel')"
             :confirmLoading="modalLoading">
        <table class="fx-form-view">
                    <tr>
                        <th>访问路径</th>
                        <td>
                            {{initData.webPath}}
                        </td>
                    </tr>
                    <tr>
                        <th>创建时间</th>
                        <td>
                            {{initData.createdAt}}
                        </td>
                    </tr>
                    <tr>
                        <th>修改时间</th>
                        <td>
                            {{initData.updatedAt}}
                        </td>
                    </tr>
                    <tr>
                        <th>状态(E:启用;D:禁用)</th>
                        <td>
                            {{initData.state}}
                        </td>
                    </tr>
        </table>
    </a-modal>
</template>

<script>
export default {
  name: 'WfCaseQueryConfig',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      initData: {},
      modalLoading: false
    }
  },
  methods: {
    init (id) {
      const that = this
      this.$http.get('/api/1/com/fxoa/epp/workflow/get_wfcasequeryconfig.json?id=' + id).then(function (response) {
        that.initData = response.result
      })
    }
  }
}
</script>

<style scoped>
</style>
